import { BlockParameters } from '@visualizer/types';
import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { PipelineBlock } from '../PipelineBlock';
import UnobstructedFilterStage, { UnobstructedFilterStageParameters } from '../stages/filters/UnobstructedFilterStage';

export type UnobstructedBlockParameters = BlockParameters & UnobstructedFilterStageParameters;

@AddMetadata({
    type: BlockKeys.Unobstructed,
    name: 'Unobstructed',
    description:
        'Keeps only those Sensor Points that will in any case not be obstructed by potential obstruction added within the site. These Sensor Points are typically located at the borders of the volume in the direction of the environmental resource',
})
class UnobstructedBlock extends PipelineBlock<UnobstructedBlockParameters> {
    constructor(params: UnobstructedBlockParameters, stringId?: string) {
        super(params, stringId);
    }

    protected override defineStages() {
        return [new UnobstructedFilterStage({ unobstructedMode: this.getParams().unobstructedMode, isValue: this.getParams().isValue })];
    }
}

export default UnobstructedBlock;
